<template>
  <div class="comment-panel container">
    <div class="row">
      <comment v-for="comment in comments"
        :comment="comment"
        :key="comment.name"/>
    </div>
  </div>
</template>

<script>
import Comment from '@/components/Comment.vue'

export default {
  name: 'CommentPanel',
  data () {
    return {
      comments: [
        {
          name: 'เจ้าของน้องลักกี้',
          title: 'Dog Owner',
          comment: 'ขอบคุณทุกท่านมากนะคะ ตอนนี้ป้าแมกกี้ได้เลือดเพียงพอพร้อมผ่าตัดในวันพรุ่งนี้แล้วค่ะ ขอบคุณมากๆ ค่ะ '
        },
        {
          name: 'เจ้าของน้อง Mac',
          title: 'Dog Owner',
          comment: 'ขอบคุณที่ช่วยเหลือนะครับ น้องรอดแล้วถ้าไม่ได้เลือดแย่แน่ๆ พยาธิเม็ดเลือดเล่นซะหนักเลย'
        },
        {
          name: 'เจ้าของน้อง Byte',
          title: 'Dog Owner',
          comment: 'น้อรอดแล้ว ขอบคุณมากๆๆๆๆ '
        }
      ]
    }
  },
  components: {
    Comment
  }
}
</script>

<style scoped lang="scss">
.comment-enter-active, .comment-leave-active {
  transition: all 1.5s;
}
.comment-enter, .comment-leave-to {
  opacity: 0;
}
</style>
